import { gql } from '@apollo/client';
import CompanyFieldsFragment from "./CompanyFields";

const BusinessNetworkRecursiveFragment = gql`
  fragment CompanyRecursive on CompanyNetwork {
    childCompanies {
      ...CompanyFields
      childCompanies {
        ...CompanyFields
        childCompanies {
          ...CompanyFields
          childCompanies {
            ...CompanyFields
            childCompanies {
              ...CompanyFields
              childCompanies {
                ...CompanyFields
              }
            }
          }
        }
      }
    }
  }

  ${CompanyFieldsFragment}
`;

export default BusinessNetworkRecursiveFragment;
